import { render, staticRenderFns } from "./LogosColumn.vue?vue&type=template&id=4affdd0d&scoped=true&"
import script from "./LogosColumn.vue?vue&type=script&lang=js&"
export * from "./LogosColumn.vue?vue&type=script&lang=js&"
import style0 from "./LogosColumn.vue?vue&type=style&index=0&id=4affdd0d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4affdd0d",
  null
  
)

export default component.exports